<template>
  <div class="contact-address">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h2>{{ direction === "origin" ? $t('orders.origin') : $t('orders.destination') }}</h2>
        </v-col>
        <v-col cols="12">
          <label for="country">{{$t('orders.company')}} *</label>
          <v-autocomplete
            v-model="address_child.company"
            background-color="#dbdbdb"
            single-line
            solo
            :items="companiesList"
            :rules="[v => !!v || $t('general.required_field')]"
          >
            <template v-slot:no-data>
              <v-col class="pl-2" cols="12">
                <p>{{$t('orders.company_not_found')}}</p>
              </v-col>
              <v-btn
                color="primary"
                dark
                @click="companyDialog = true"
              >{{$t('companies.create_new_btn')}}</v-btn>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12">
          <label for="location">{{ direction === "origin" ? $t('orders.location_pickup') : $t('orders.location_delivery') }} *</label>
          <v-autocomplete
            :disabled="address_child.company === ''"
            :placeholder="address_child.company === ''? $t('orders.company_must_be_filled'): ''"
            v-model="address_child.location"
            background-color="#dbdbdb"
            single-line
            solo
            :items="locationsList"
            :rules="[v => !!v || $t('general.required_field')]"
          >
            <template v-slot:no-data>
              <v-col class="pl-2" cols="12">
                <p>{{$t('orders.location_not_found')}}</p>
              </v-col>
              <v-btn
                color="primary"
                dark
                @click="locationDialog = true"
              >{{$t('locations.create_new_btn')}}</v-btn>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12">
          <label for="contact">{{ direction === "origin" ? $t('orders.contact_origin') : $t('orders.contact_destination') }}</label>
          <v-autocomplete
            :disabled="address_child.company === ''"
            :placeholder="address_child.company === ''? $t('orders.company_must_be_filled'): ''"
            v-model="address_child.contact_person"
            background-color="#dbdbdb"
            single-line
            solo
            :items="contactPersonList"
          >
            <template v-slot:no-data>
              <v-col class="pl-2" cols="12">
                <p>{{$t('orders.contact_not_found')}}</p>
              </v-col>
              <v-btn
                color="primary"
                dark
                @click="contactDialog = true"
              >{{$t('orders.contact_new_btn')}}</v-btn>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12">
          <label for="referenceNumber">{{$t('orders.ref_number')}}</label>
          <v-text-field
            :disabled="direction === 'origin' && isUpdate"
            v-model="address_child.reference_number"
            background-color="#dbdbdb"
            single-line
            solo
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <label for="open_hours">{{ direction === "origin" ? $t('orders.open_hours_origin') : $t('orders.open_hours_destination') }}</label>
          <v-row>
            <v-col
              cols="11"
              sm="5"
            >
              <v-menu
                ref="menu_from"
                v-model="time_menu_from"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="address_child.open_from"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="address_child.open_from"
                    :label="$t('orders.open_from')"
                    prepend-icon="access_time"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="time_menu_from"
                  v-model="address_child.open_from"
                  format="24hr"
                  color="kazan"
                  header-color="#212121"
                  full-width
                  @click:minute="$refs.menu_from.save(address_child.open_from)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col
              class="hidden-xs-only"
              align-self="center"
              sm="1"
              style="text-align: center"
            >
              -
            </v-col>
            <v-col
              cols="11"
              sm="5"
            >
              <v-menu
                ref="menu_to"
                v-model="time_menu_to"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="address_child.open_to"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="address_child.open_to"
                    :label="$t('orders.open_to')"
                    prepend-icon="access_time"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="time_menu_to"
                  v-model="address_child.open_to"
                  format="24hr"
                  color="kazan"
                  header-color="#212121"
                  full-width
                  @click:minute="$refs.menu_to.save(address_child.open_to)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          class="mt-3"
          cols="12"
          md="11"
        >
          <v-menu
            v-model="date_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="address_child.dates"
                :label="date_label"
                prepend-icon="event"
                readonly
                v-on="on"
                :rules="[v => !!v || $t('general.required_field')]"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="address_child.dates"
              color="kazan"
              header-color="#212121"
              :locale="$i18n.locale"
              @input="date_menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="mt-2" cols="12" v-if="direction === 'origin' && address_child.orderStatus !== undefined">
          <label for="orderStatus">{{$t('orders.order_status')}}</label>
          <v-select
            :items="orderStatus"
            v-model="address_child.orderStatus"
            single-line
            solo
          ></v-select>
        </v-col>
      </v-row>
    </v-container>
    <CompanyNewDialog v-if="companyDialog" v-model="companyDialog" />
    <LocationNewDialog
      v-if="locationDialog"
      v-model="locationDialog"
      :companyName="address_child.company"
    />
    <ContactNewDialog
      v-if="contactDialog"
      v-model="contactDialog"
      :companyName="address_child.company"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CompanyNewDialog from '@/components/companies/CompanyNewDialog.vue'
import LocationNewDialog from '@/components/locations/LocationNewDialog.vue'
import ContactNewDialog from '@/components/contacts/ContactNewDialog.vue'

export default {
  name: 'ContactAddress',
  components: {
    CompanyNewDialog,
    LocationNewDialog,
    ContactNewDialog
  },
  props: {
    direction: String,
    value: Object,
    isUpdate: Boolean
  },
  data () {
    return {
      time_menu_from: false,
      time_menu_to: false,
      date_menu: false,
      address_child: JSON.parse(JSON.stringify(this.value)),
      companyDialog: false,
      locationDialog: false,
      contactDialog: false,
      orderStatus: [
        'Status A',
        'Status B',
        'Status C'
      ]
    }
  },
  computed: {
    ...mapState(['route', 'orders', 'locations']),
    locationsList () {
      // console.log(this.address_child.company)

      let locs = Object.values(this.locations.data)
        .filter(loc => {
          return loc.company === this.address_child.company
        })

      return locs.map(function (loc) {
        return `${loc.address.street} ${loc.address.street_number}, ${loc.address.city} ${loc.address.postal_code}, ${loc.address.country_code}`
      })
    },
    companiesList () {
      const resultSet = new Set()
      Object.values(this.locations.data).forEach(element => {
        resultSet.add(element.company)
      })
      return Array.from(resultSet)
    },
    contactPersonList () {
      return ['Person A', 'Person B', 'Person C']
    },
    date_label () {
      return (this.direction === 'origin' ? this.$i18n.t('orders.date_origin') : this.$i18n.t('orders.date_destination')) + ' *'
    }
  },
  watch: {
    address_child: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    ...mapActions({
      updateOrder: 'updateOrder',
      fetchOrders: 'fetchOrders',
      fetchLocations: 'fetchLocations'
    })
  },
  mounted () {
    // this.fetchLocations()
  }
}
</script>

<style scoped>
.contact-address {
  padding: 15px;
}
.flex {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.from-directory-btn {
  float: right;
  margin: 0;
}
/* .v-btn--active {
        background-color: #ff5252 !important;
        color: white !important;
    } */
.v-picker {
  margin-top: 15px;
}
table.v-table tbody tr {
  cursor: pointer;
}
</style>
